export default "__VITE_ASSET__B$3Nt56h__"